import CryptoJS from 'crypto-js/crypto-js.js'
import AES from 'crypto-js/aes.js'
import sha512 from 'crypto-js/sha512.js'
import {langControl} from '@/scripts/istore-ui-lang.js';

export default {

  ctr_array: [7, 3, 11, 5, 6, 8, 16, 9, 10, 1, 12, 13, 4, 14, 2, 15],
  crt_hex: '07030b05060810090a010c0d040e020f',
  crt_count: '0000000000000000007128AFCFEF1315',

  getUrlParam(paramName, defaultValue) {
    let GetUrl = window.location.href
    if (GetUrl.indexOf(paramName) >= 0) {
      let UrlParams =
        (GetUrl.split('?', 2)[1] || '').split('#')[0].split('&') || []
      for (let i = 0; i < UrlParams.length; i++) {
        let single = UrlParams[i].split('=')
        //是否為要取的參數
        if (single[0] === paramName) {
          return decodeURI(single[1])
        }
      }
    }
    if (defaultValue) {
      return defaultValue
    }
    return ''
  },
  getUrlParamBySearch(search, paramName, defaultValue) {
    let getUrl = search
    if (getUrl.indexOf(paramName) >= 0) {
      let UrlParams =
        (getUrl.split('?', 2)[1] || '').split('#')[0].split('&') || []
      for (let i = 0; i < UrlParams.length; i++) {
        let single = UrlParams[i].split('=')
        //是否為要取的參數
        if (single[0] === paramName) {
          return decodeURI(single[1])
        }
      }
    }
    if (defaultValue) {
      return defaultValue
    }
    return ''
  },
  chineseToUnicode(chineseString) {
    let unicodeString = '';
    for (let i = 0; i < chineseString.length; i++) {
      if (chineseString.charCodeAt(i) < 256) {
        unicodeString += String.fromCharCode(chineseString.charCodeAt(i))
      } else {
        let unicode = chineseString.charCodeAt(i).toString(16).toUpperCase();
        while (unicode.length < 4) {
          unicode = '0' + unicode;
        }
        unicodeString += '\\u' + unicode;
      }
    }
    return unicodeString;
  },
  encode(_text) {
    //return this.ctr(_text, false);

    let returnValue = null;
    let encryption = AES.encrypt(_text, CryptoJS.enc.Hex.parse(this.crt_hex), {
      iv: CryptoJS.enc.Hex.parse(this.crt_count), mode: CryptoJS.mode.CTR, padding: CryptoJS.pad.NoPadding,
    });
    returnValue = encryption.ciphertext.toString();
    return returnValue

  },
  decode(_text) {
    try {
      //return this.ctr(_text, true);

      let returnValue = null;

      let yy = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(_text));
      let key = CryptoJS.enc.Hex.parse(this.crt_hex);
      let nonceAndCounter = CryptoJS.enc.Hex.parse(this.crt_count);
      returnValue = AES.decrypt(yy, key, {
        iv: nonceAndCounter, mode: CryptoJS.mode.CTR, padding: CryptoJS.pad.NoPadding,
      });
      returnValue = returnValue.toString(CryptoJS.enc.Utf8);

      return returnValue;

    } catch (error) {
      console.error(error)
      return _text;
    }
  },
  sha512(text) {
    return sha512(text).toString();
  },
  unixToDate(timestamp) {
    // Create a new Date object using the Unix timestamp multiplied by 1000 (to convert it to milliseconds)
    if (typeof(timestamp) !== "number") return
    const date = timestamp.toString().length !== 13 ? new Date(timestamp * 1000) : new Date(timestamp)
    // Get the individual date and time components from the Date object
    const year = (date.getFullYear()).toString().padStart(4, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are zero-based, so add 1
    const day = (date.getDate()).toString().padStart(2, '0')
    const hours = (date.getHours()).toString().padStart(2, '0')
    const minutes = (date.getMinutes()).toString().padStart(2, '0')
    const seconds = (date.getSeconds()).toString().padStart(2, '0')
    // Format the date and time components into a human-readable string
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
  },
  apiTimeoutPromise(milliseconds, errorMessage) {
    // Helper function for API timeout call
    return new Promise((_, reject) => setTimeout(() => reject(new Error(errorMessage)), milliseconds))
  },
  toCamelCase(string) {
    return string
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        // If the word is a number, return it as is; otherwise, capitalize the first letter
        return !isNaN(word) || index === 0 
          ? word 
          : word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join('')
  },
  toPascalCase(string) {
    return string
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('')
  },
  generateUid(charLength) {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
    const length = charLength

    let result = ''
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length)
      result += characters[randomIndex]
    }

    return result
  },
  generateTrackingUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  },
  buildFolder(funcList) {
    if (!funcList) {
      console.error('No any function!')
      return;
    }

    console.debug('buildFolder', funcList)

    funcList.sort((v1, v2) => {
      let o1 = typeof v1.order === 'string' ? parseInt(v1.order) : v1.order
      let o2 = typeof v2.order === 'string' ? parseInt(v2.order) : v2.order
      return o1 > o2 ? 1 : -1
    })

    const functions = []
    const folderIcon = []
    for (const func of funcList) {
      if (func.parent) {
        // 此功能有目錄
        const folders = func.parent.split('.')
        // Initialize root parent as empty for top-level folder
        let parentFolder = null
        // 多層目錄，用逗號分隔
        for (let i = 0; i < folders.length; i++) {
          let folderName = folders[i]
          let parent = ''
          let parentKey = ''
          let parentKeys = []
          if (i !== 0) {
            // 非第一位，代表有父項目錄
            parent = folders[i - 1]
            parentKey = parent + (i - 1)
          }

          // Check if current folder already exists in function tree ("functions" variable)
          let currentFolder = this.findFolder(functions, parentFolder ? parentFolder.folderName : "", folderName, i)
          if (!currentFolder) {
            // 尚未新增的目錄
            // 目錄基本資料結構
            const newFolder = {
              parent: parentFolder ? parentFolder.folderName : "",
              parentKey,
              parentKeys,
              folderName,
              folderLevel: i,
              folders: [],
              functions: [],
              key: folderName + i,
              opened: false,
              order: -1,
              checked: false,
              isFolder: true,
              createChecked: false,
              viewChecked: false,
              editChecked: false,
              deleteChecked: false,
            }
            newFolder.folderDisplayName = langControl.currentLangKey[`folder.level${i}.${folderName}`] ?? folderName

            if (parentFolder) {
              // 非第一順位，有父項目錄，找到父項找自己加到父項的.folders
              parentFolder.folders.push(newFolder)
            } else {
              // 第一順位，沒有父項
              functions.push(newFolder)
              folderIcon[folderName + i] = 'Y'
            }
            currentFolder = newFolder
          }
          parentFolder = currentFolder // Propagate the current folder as the next upper folder
        }
      } else {
        functions.push(func)
      }
    }

    // 為原始的功能物件補上父項目錄的Key
    for (const func of funcList) {
      const folders = func.parent.split('.')
      let maxIndex = folders.length-1
      for (let index = folders.length-1; index >= 0; index--) {
        const element = folders[index];
        let folderName = element
        let parent = folders[index - 1] !== undefined ? folders[index - 1] : ""
        let folder = this.findFolder(functions, parent, folderName, index)
        if (folder) {
          func.parentKey = folder.key
          if(index == maxIndex){
            folder.functions.push(func)//父項目錄加入功能
          }
          if (folder.order === -1) {
            folder.order = func.order
          }
          if (func.checked) {
            folder.checked = true
          }
        }
      }
    }

    // Preventing 'order' key set to -1 on the outermost Object
    function updateOrder(obj) {
      if (obj.functions && obj.functions.length > 0) {
        // Update 'order' for leaf nodes with the smallest 'order' value
        const smallestOrder = Math.min(...obj.functions.map(func => func.order))
        obj.order = smallestOrder
      } else if (obj.folders && obj.folders.length > 0) {
        // If it's not a leaf node, update recursively for nested folders
        obj.folders.forEach(folder => updateOrder(folder))
        // Propagate the 'order' value from the deepest Object
        const deepestOrder = Math.min(...obj.folders.map(folder => folder.order))
        obj.order = deepestOrder
      }
    }

    // Iterate through each object in the array, and update 'order' key
    functions.forEach(obj => {
      updateOrder(obj)
    })

    functions.sort((v1, v2) => {
      let o1 = typeof v1.order === 'string' ? parseInt(v1.order) : v1.order
      let o2 = typeof v2.order === 'string' ? parseInt(v2.order) : v2.order
      return o1 > o2 ? 1 : -1
    })

    for (let item of functions) {
      this.fullParentKeys(item, [], 0)
    }

    return {functions, folderIcon}
  },
  findFolder(_functions, _parent, _name, _level) {
    for (let f of _functions) {
      if (f.parent === _parent && f.folderName === _name && f.folderLevel === _level) {
        return f
      } else if (f.folders && f.folders.length > 0) {
        let _tmp = this.findFolder(f.folders, _parent, _name, _level)
        if (_tmp) {
          return _tmp
        }
      }
    }
  },

  // 補滿 parentKeys
  fullParentKeys(item, keys, depth) {
    if (item.folders) {
      for (let folder of item.folders) {
        const element = folder;
        element.parentKeys = [].concat(keys)
        element.parentKeys.push(item.key)
        this.fullParentKeys(element,element.parentKeys,(depth+1))
      }
    }
    if (item.functions) {
      for (let myFunction of item.functions) {
        const element = myFunction;
        element.parentKeys = [].concat(keys)
        element.parentKeys.push(item.key)
      }
    }
  },
  uuid() {
    let returnValue = [];
    const hexDigits = "0123456789ABCDEF";
    for (let loop = 0; loop < 36; loop++) {
      returnValue[loop] = hexDigits.substr(Math.floor((window.crypto.getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32)) * 0x10), 1);
    }
    returnValue[14] = "4";
    returnValue[19] = hexDigits.substr((returnValue[19] & 0x3) | 0x8, 1);
    returnValue[8] = returnValue[13] = returnValue[18] = returnValue[23] = "-";
    return returnValue.join("");
  },
  clone(obj){
    return JSON.parse(JSON.stringify(obj))
  },
  async getBase64ImageFromUrl(imageUrl) {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  },
  jsonToFormData(jsonData) {
    const parsedJsonData = JSON.parse(jsonData)
    const formData = new FormData()
    for (const key in parsedJsonData) {
      formData.append(key, parsedJsonData[key])
    }
    return formData
  }
}
